"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonScheduleModel = void 0;
const core_1 = require("@veeam/core");
const baseTypes_1 = require("../../../core/baseTypes");
const types_1 = require("../types");
class CommonScheduleModel extends core_1.Model {
    constructor(initialValue) {
        super(initialValue);
        this.isRowExistingAndEnabled = (scheduleRow) => {
            const row = this.getValue().rows[scheduleRow];
            return !!row && row.isEnabled;
        };
        this.isFirstRowExistingAndEnabled = () => {
            return this.isRowExistingAndEnabled(types_1.SCHEDULE_ROW.first);
        };
        this.isSecondRowExistingAndEnabled = () => {
            return this.isRowExistingAndEnabled(types_1.SCHEDULE_ROW.second);
        };
        this.isThirdRowExistingAndEnabled = () => {
            return this.isRowExistingAndEnabled(types_1.SCHEDULE_ROW.third);
        };
    }
    static getRow(modelValue, rowKey) {
        return modelValue.rows[rowKey];
    }
    static getRowField(modelValue, rowKey) {
        var _a;
        return (_a = CommonScheduleModel.getRow(modelValue, rowKey)) === null || _a === void 0 ? void 0 : _a.fields;
    }
    static getRowSchedule(modelValue, rowKey) {
        var _a;
        return (_a = CommonScheduleModel.getRow(modelValue, rowKey)) === null || _a === void 0 ? void 0 : _a.schedule;
    }
    static isFieldCount(field) {
        return !!field && typeof field === 'number';
    }
    static isFieldType(field) {
        return !!field && Object.values(baseTypes_1.RETENTION_TYPE).includes(field);
    }
    static getRowFieldCount(modelValue, rowKey) {
        const field = CommonScheduleModel.getRowField(modelValue, rowKey);
        if (CommonScheduleModel.isFieldCount(field === null || field === void 0 ? void 0 : field.count)) {
            return field === null || field === void 0 ? void 0 : field.count;
        }
        return;
    }
    static getRowFieldType(modelValue, rowKey) {
        const field = CommonScheduleModel.getRowField(modelValue, rowKey);
        if (CommonScheduleModel.isFieldType(field === null || field === void 0 ? void 0 : field.type)) {
            return field === null || field === void 0 ? void 0 : field.type;
        }
        return;
    }
}
exports.CommonScheduleModel = CommonScheduleModel;
//# sourceMappingURL=CommonScheduleModel.js.map